type RuntimeWindow = Window & {
  __FINTHEON_API_BASE__?: string;
  electron?: {
    apiBase?: string;
  };
};

const LOCAL_HOST_PATTERN = /^(localhost|127\.0\.0\.1)$/i;

export function getBrowserApiBase(
  developerFallback = "http://localhost:8080",
): string {
  const runtimeBase = readRuntimeApiBase();
  if (runtimeBase) return runtimeBase;

  if (isRemoteBrowserHost()) return "";

  const envBase = stripTrailingSlash(import.meta.env.VITE_API_URL ?? "");
  if (envBase) {
    return envBase;
  }

  return envBase || developerFallback;
}

function readRuntimeApiBase(): string | null {
  if (typeof window === "undefined") return null;
  const runtimeWindow = window as RuntimeWindow;
  const raw =
    runtimeWindow.__FINTHEON_API_BASE__ || runtimeWindow.electron?.apiBase;
  return raw ? stripTrailingSlash(raw) : null;
}

function isRemoteBrowserHost(): boolean {
  if (typeof window === "undefined") return false;
  if (!/^https?:$/.test(window.location.protocol)) return false;
  return !LOCAL_HOST_PATTERN.test(window.location.hostname);
}

function stripTrailingSlash(value: string): string {
  return value.trim().replace(/\/$/, "");
}
